export const getPostDateString = (date, culture) => {
    if (date === undefined || date === null) {
        return "";
    }

    var locale = culture.split('-')[0];
    var month = new Intl.DateTimeFormat(locale, { month: 'long' }).format(date)
    
    var splittedDate = date.toString().split(" ");
    var splittedHours = splittedDate[4].split(":");
    var eventDate = month + " " + splittedDate[2] + ", " + splittedHours[0] + ":" + splittedHours[1] + " GMT";

    return eventDate;
};

export const getOrdinalDay = (day) => {
    switch (day) {
        case "one":
            return "st";
        case "two":
            return "nd";
        case "few":
            return "rd";
        default:
            return "th";
    }
};
